import { User } from '@/api/rest/resources/types/user';

export const printFullName = (user: User) => {
  return `${user.firstname} ${user.lastname}`;
};

export const printInitials = (user: User) => {
  return `${user.firstname.slice(0, 1)}${user.lastname.slice(0, 1)}`;
};
